<div class="container">
    <div class="row">
        <div class="col-sm-12 mt-2 word-wrap">
            <h4 [innerHtml]="cplItem.Title"></h4><hr>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-print-4">
            <label>Person(s) of Contact: </label>
            <ul>
                <li *ngFor="let contact of ContactUsers" [innerHtml]="contact.DisplayName"></li>
            </ul>
            <div *ngIf="cplItem.ItemType == 0">
                <div class="col-sm-12 small"><span class="fw-bold">Start Date:</span> {{cplItem.StartDate | date: 'MMMM dd, yyyy' }}</div>
                <div class="col-sm-12 small"><span class="fw-bold">End Date:</span> {{cplItem.EndDate | date: 'MMMM dd, yyyy' }}</div>
            </div>
        </div>
        <div class="col-md-8 col-print-8 d-grid gap-3">
            <div class="row" *ngIf="isAct48Enabled()">
                <label>Act 48 Details </label>
                <div class="col-sm-12 small"><span class="fw-bold">{{a48HelpersService.getHoursOrCreditsFullLabel(cplItem.Act48Detail.ActivityType)}}:</span> {{cplItem.Act48Detail.Hours}}</div>
                <div class="col-sm-12 small"><span class="fw-bold">Provider:</span> {{cplItem.Act48Detail.Provider}}</div>
                <div class="col-sm-12 small" *ngIf="A48Labels?.AUNLabel"><span class="fw-bold">AUN: {{A48Labels?.AUNLabel}}</span></div>
                <div class="col-sm-12 small"><span class="fw-bold">Activity Type:</span> {{A48Labels?.ActivityType}}</div>
                <div class="col-sm-12 small"><span class="fw-bold">Course Type:</span> {{A48Labels?.CourseType}}</div>
                <div *ngIf="A48Labels?.CollegeCreditType" class="col-sm-12 small"><span class="fw-bold">College Credit Type:</span> {{A48Labels?.CollegeCreditType}}</div>
                <div class="col-sm-12 small" *ngIf="cplItem.Act48Detail.ParaApplicable"><span class="fw-bold">CEC Performance Based Standard:</span> {{A48Labels?.CECPerformanceStandard}}</div>
            </div>
            <edl-time-tracking-summary
                [details]="cplItem?.FlexDetails"
                [config]="{ shouldBoldLabels: true }"
            ></edl-time-tracking-summary>
        </div>
    </div>
    <div>
        <div class="col-sm-12">
            <table class="print-table table table-bordered" style="margin-top: 25px;">
                <caption class="visually-hidden">Roster sign-in sheet with name, signature, time in, and time out columns</caption>
                <thead>
                <tr>
                    <th scope="col" class="fit no-wrap">Name</th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col" width="8%">Time In:</th>
                    <th scope="col" width="8%">Time Out:</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let user of Roster">
                    <td [innerHtml]="user" class="fit no-wrap"></td>
                    <td>&nbsp;</td>
                    <td></td><td></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>